import { render, staticRenderFns } from "./DoctorsComponent.vue?vue&type=template&id=7e6bdcd0&scoped=true&"
import script from "./DoctorsComponent.vue?vue&type=script&lang=js&"
export * from "./DoctorsComponent.vue?vue&type=script&lang=js&"
import style0 from "./DoctorsComponent.vue?vue&type=style&index=0&id=7e6bdcd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6bdcd0",
  null
  
)

export default component.exports